module.exports = __webpack_public_path__ + "media/images/emblems/Obfelden-blazon-87e3f7da3c89f86ba6154a2668b574c5.svg";